<template>
  <div class="app-wrap" data-qa="patient-verify-payment-page">
    <div v-if="loading" class="loading-wrapper">
      <updox-loading color="#003462" size="80px" />
    </div>
    <div v-else-if="error">
      <updox-error :error-details="errorDetails" />
    </div>
    <div v-else-if="preverificationStatus === 'PAYMENT_INVALID_STATE'">
      <section class="main-header">
        <div class="primary-header page-wrapper flex-column align-center">
          <h2>{{ this.$store.getters.hipaaSafePracticeName }}</h2>
        </div>
      </section>
      <section class="secondary-header">
        <div class="page-wrapper flex-column align-center">
          <p>
            <em>Payment requested on {{ paymentRequestDate }}</em>
          </p>
        </div>
      </section>
      <section class="page-wrapper">
        <updox-payment-invalid-state
          :invalid-state="this.$store.getters.paymentDetails.invalidState"
        />
      </section>
    </div>
    <div v-else-if="preverificationStatus === 'TOKEN_NOT_FOUND'">
      <updox-bad-payment-request-token />
    </div>
    <div v-else-if="preverificationStatus === 'PRACTICE_UNABLE_TO_PROCESS'">
      <updox-cannot-process-payments />
    </div>
    <div v-else>
      <section class="main-header">
        <div class="primary-header page-wrapper flex-column align-center">
          <h2>{{ this.$store.getters.hipaaSafePracticeName }}</h2>
        </div>
      </section>
      <section class="secondary-header">
        <div class="page-wrapper flex-column align-center">
          <p>
            <em>Payment requested on {{ paymentRequestDate }}</em>
          </p>
        </div>
      </section>
      <section class="page-wrapper">
        <h3>Verify identity</h3>
        <payment-validate-form
          :forms-data="loadedForm"
          v-on:parent-status="setPreverificationStatus"
          v-on:parent-error="setError"
        />
      </section>
    </div>

    <updox-footer />
  </div>
</template>

<script>
  import PaymentValidateForm from "../components/PaymentValidateForm";
  import { UpdoxLoading } from "@updox/common-vue";
  import UpdoxBadPaymentRequestToken from "../components/common/UpdoxBadPaymentRequestToken";
  import UpdoxCannotProcessPayments from "../components/common/UpdoxCannotProcessPayments";
  import UpdoxPaymentInvalidState from "../components/common/UpdoxPaymentInvalidState";
  import UpdoxError from "../components/common/UpdoxError";
  import UpdoxFooter from "../components/common/UpdoxFooter";
  import SimplePaymentsPatientService from "../services/SimplePaymentsPatientService";
  import moment from "moment";

  export default {
    name: "PaymentValidate",
    data: () => ({
      loading: true,
      error: false,
      errorDetails: null,
      preverificationStatus: null,
      // This is borrowing from a pattern updox/forms uses; for client-side only forms, we can mock the data and make reuse of all of the
      // pre-built ux. Things like field validation, submit ui state, and error handling.
      loadedForm: {
        fields: [
          {
            type: "dateOfBirth",
            label: "Date of Birth",
            id: "dateOfBirth",
            placeholder: "",
            required: true,
            value: "",
          },
          {
            type: "textbox",
            label: "First Name",
            id: "firstName",
            placeholder: "Enter first name",
            required: true,
            value: "",
          },
          {
            type: "textbox",
            label: "Last Name",
            id: "lastName",
            placeholder: "Enter last name",
            required: true,
            value: "",
          },
        ],
      },
    }),
    components: {
      PaymentValidateForm,
      UpdoxLoading,
      UpdoxBadPaymentRequestToken,
      UpdoxCannotProcessPayments,
      UpdoxPaymentInvalidState,
      UpdoxError,
      UpdoxFooter,
    },
    async mounted() {
      const { paymentRequestToken } = this.$route.params;

      // Since this is pre-verification data, it's sensitive; practice Phone number was purposively, excluded.
      SimplePaymentsPatientService.getPreverificationDetails(
        paymentRequestToken
      )
        .then((response) => {
          // TODO: hipaaSafePracticeName would be nice when not OK and TOKEN_NOT_FOUND, no?
          this.preverificationStatus = response?.status;

          if (
            response?.status === "OK" ||
            response?.status === "PAYMENT_INVALID_STATE"
          ) {
            const remainingVerificationAttempts =
              response?.remainingVerificationAttempts;
            const paymentStatus = response?.status;
            const hipaaSafePracticeName = response?.hipaaSafePracticeName;
            const paymentRequestDate = response?.paymentRequestDate;
            const invalidState = response?.invalidState;

            // $store PatientPreVerificationPaymentDetailsResponse objects so we can them later for PaymentRemit and PaymentReceipt
            this.$store.commit(
              "setHipaaSafePracticeName",
              hipaaSafePracticeName
            );
            this.$store.commit("setPaymentRequestDate", paymentRequestDate);
            this.$store.commit("setPaymentStatus", paymentStatus);
            this.$store.commit("setPaymentInvalidState", invalidState);
            this.$store.commit(
              "setRemainingVerificationAttempts",
              remainingVerificationAttempts
            );
          }
        })
        .catch((error) => {
          let {
            response: { status: errorCode },
          } = error;
          if (typeof errorCode == "undefined" || 401 !== errorCode) {
            this.error = true;
            this.errorDetails = error;
            /*airbrake.notify({
              error: e,
              message: "Unable to process payment token"
            });*/
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    methods: {
      setPreverificationStatus(status) {
        this.preverificationStatus = status;
      },
      setError(e) {
        this.error = true;
        console.log(e);
        //this.errorDetails = ;
      },
    },
    computed: {
      // Just for display in the secondary-header
      paymentRequestDate() {
        return moment(this.$store.getters.paymentRequestDate).format(
          "MMMM Do, YYYY"
        );
      },
    },
  };
</script>

<style scoped lang="scss">
/*We need to import the global styles for each view in order for the compiled web component to inherit the global and updox-styles styling*/
@import "@/assets/_scss/main";

  .loading-wrapper {
    padding-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .page-wrapper {
    margin: 0 auto;
    width: 300px;

    h3 {
      font-size: 18px;
      font-weight: 600;
    }
  }

  .main-header {
    position: relative;
    color: #222;
    background: #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    z-index: 101;
    width: 100%;

    .primary-header {
      position: relative;
      text-align: center;

      h2 {
        font-weight: 600;
      }

      small {
        font-size: 12px;
        margin-bottom: 10px;
      }
    }
  }

  .secondary-header {
    background: #edf6f9;
    border: 1px solid rgba(0, 127, 173, 0.1);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    position: relative;
    color: #000;
    z-index: 101;
    width: 100%;

    p {
      margin: 8px 0;
    }
  }
</style>
